var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconSearch24 = function SvgAIconSearch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3998 16.7994C13.9342 16.7994 16.7995 13.9341 16.7995 10.3997C16.7995 6.86516 13.9342 3.99989 10.3998 3.99989C6.86527 3.99989 4 6.86516 4 10.3997C4 13.9341 6.86527 16.7994 10.3998 16.7994Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7324 15.7328L19.9989 19.9999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconSearch24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMzk5OCAxNi43OTk0QzEzLjkzNDIgMTYuNzk5NCAxNi43OTk1IDEzLjkzNDEgMTYuNzk5NSAxMC4zOTk3QzE2Ljc5OTUgNi44NjUxNiAxMy45MzQyIDMuOTk5ODkgMTAuMzk5OCAzLjk5OTg5QzYuODY1MjcgMy45OTk4OSA0IDYuODY1MTYgNCAxMC4zOTk3QzQgMTMuOTM0MSA2Ljg2NTI3IDE2Ljc5OTQgMTAuMzk5OCAxNi43OTk0WiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xNS43MzI0IDE1LjczMjhMMTkuOTk4OSAxOS45OTk5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";